import { useQuery, useQueryClient, } from '@tanstack/react-query';
import { useEffect } from 'react';
import { useUserUUID } from '@annunciate/core';
import { DOWNLOAD_CACHE_KEY, fetcher } from '../../utils';
export const useDownloadQuery = (item, options) => {
    const uuid = useUserUUID(true);
    const client = useQueryClient();
    const cacheKey = item
        ? [`${DOWNLOAD_CACHE_KEY}:${uuid}`, { id: item.id }]
        : [DOWNLOAD_CACHE_KEY];
    const query = useQuery({
        queryKey: cacheKey,
        queryFn: async () => fetcher(client, item, uuid),
        gcTime: Infinity,
        staleTime: Infinity,
        ...options,
    });
    useEffect(() => {
        query.refetch();
    }, [
        uuid,
    ]);
    return query;
};
//# sourceMappingURL=useDownloadQuery.js.map